const getProjectId = (state) => { return state.activeProjectId }
const getStatus = (state) => { return state.status }

export default {
  getProjectId,
  getStatus
}
